// Carrello Looniva: aggiunge il suggerimento e lo riaggiorna quando il
// carrello cambia (evento di Haven "theme-cart:updated").
(() => {
  const qc = () => document.querySelector('section-quick-cart');
  const refresh = async () => {
    const el = qc();
    if (!el) return;
    const res = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=${el.dataset.sectionId}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const next = doc.querySelector('[data-lv-cart-sug]');
    const cur = document.querySelector('[data-lv-cart-sug]');
    if (next && cur) cur.replaceWith(next);
  };
  document.addEventListener('theme-cart:updated', () => { refresh().catch(console.error); });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-lv-sug-add]');
    if (!b) return;
    b.disabled = true;
    try {
      const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.lvSugAdd), quantity: 1 }] }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        document.dispatchEvent(new CustomEvent('theme-cart:updated', {
          detail: {
            shouldOpenCart: false,
            error: data.description || data.message || '',
            productTitle: b.dataset.lvSugTitle || '',
          },
        }));
        return;
      }
      document.dispatchEvent(new CustomEvent('theme-cart:updated', { detail: { shouldOpenCart: false } }));
    } finally { b.disabled = false; }
  });
})();
